module.exports = __webpack_public_path__ + "img/footer.15c809e.png";